/**
 * Trunnion AI - Edge Type Registry
 */

import type { ComponentType } from 'react';
import type { EdgeProps } from '@xyflow/react';
import { DataFlowEdge } from './DataFlowEdge';
import { ConditionalEdge } from './ConditionalEdge';

export const edgeTypes: Record<string, ComponentType<EdgeProps>> = {
  dataFlow: DataFlowEdge as unknown as ComponentType<EdgeProps>,
  conditional: ConditionalEdge as unknown as ComponentType<EdgeProps>,
};
